import { useEffect, useState } from 'react'

const GITLAB_STATUS = process.env.GITLAB_STATUS || null

/**
 * @function useIsDev - используется для проверки на dev окружение
 * @returns {boolean} - true если проект запущен в любом месте кроме прода
 */
const useIsDev = (): boolean => {
  const [isDev, setIsDev] = useState(false)

  useEffect(() => {
    const IS_PROD =
      GITLAB_STATUS &&
      GITLAB_STATUS === '0' &&
      typeof window !== 'undefined' &&
      window?.document?.location?.host === 'www.afisha.ru'
    setIsDev(!IS_PROD)
  }, [])

  return isDev
}

export default useIsDev
